module.exports = __webpack_public_path__ + "img/empty.bb8d2acb.png";